(function () {
  'use strict';

  angular
    .module('vcdms.vcscan')
    .config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcdmsscan', {
        url: '/vcdmsscan',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;scansorter file=""  parentsave=""&gt;</tt></h3><div ui-view="scansorterview"></div>
              <h3 class="alert alert-info"><tt>&lt;scancounter&gt;</tt></h3><div ui-view="scancounterview"></div>
              <h3 class="alert alert-info"><tt>&lt;signoffcounter&gt;</tt></h3><div ui-view="signoffcounterview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdmsvcscan entered');
        }
      });


    $stateProvider
      .state('playground.vcdmsscan.allcomponents', {
        url: '/allcomponents',
        resolve: {
          scan: function () {
            return '';
          },
          scanref: function () {
            return '';
          },
          somescan: function (File) {
            return File.$find('572b31b07c01597e3e150923');
          },
          allscans: function (File) {
            return File.$search({active: true});
          },
          parentsavesearch: function () {
            return function (file) {
              console.log('debug: dummy parentsave called for scansorter with: ', file);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'scansorterview@playground.vcdmsscan': {
            component: 'scansorter',
            bindings: {
              file: 'scan',
              parentsave: 'parentsavesearch'
            }
          },
          'scancounterview@playground.vcdmsscan': {
            component: 'scancounter',

          },
          'signoffcounterview@playground.vcdmsscan': {
            component: 'signoffcounter'
          }
        },
        onEnter: function () {
          console.log('playground.vcdmsscan.allcomponents entered');
        }
      });


  }// all routes


}());
